import React, { Component } from 'react';
import { connect } from 'react-redux';
class Container extends Component {
    render() {
        return (
            <div>
                {this.props.children}
            </div>
        );
    }
}


export default connect(null, null)(Container);


// WEBPACK FOOTER //
// ./src/components/container.js